import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';

import * as yup from 'yup';

/** Banner create or update request body */
export interface BannerFormInterface {
  /** Banner display name */
  name: string;
  /** Banner display text message */
  text: string;
  /** Start of banner display */
  start: Date;
  /** End of banner display */
  end?: Date;
  /** Color of banner */
  color: string;
  /** Clients this banner belongs to */
  clients?: ClientFindInterface[];
  /** Rooms this banner belongs to */
  rooms?: RoomFindInterface[];
}

/** Banner create or update request body - DTO schema */
export const BannerFormDto = SerdeDtoClass.create<BannerFormInterface>(ClientDtoKeysEnum.BANNER_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  text: {
    label: 'Текст',
    serializer: nonEmptyStringSchema,
  },
  start: {
    label: 'Начало периода показа',
    serializer: yup.date(),
  },
  end: {
    optional: true,
    label: 'Конец периода показа',
    serializer: yup.date(),
  },
  color: {
    label: 'Цвет',
    serializer: hexColorSchema,
  },
  clients: {
    optional: true,
    label: 'Клиенты',
    checkers: [ClientCheckerKeysEnum.CLIENT_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
  rooms: {
    optional: true,
    label: 'Помещения',
    checkers: [CatalogCheckersEnum.ROOM_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
});
